import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { IdentityService } from 'src/app/identity/identity.service';
import { FuncsService, passwordsDontMatchValidator } from 'src/app/shared/funcs.service'
import { GenericResponse } from 'src/app/api-interfaces';
import { Observable, Subscription } from 'rxjs';
import { LogService } from '../log.service';
import { User } from 'src/app/identity/user.model';
import { AuthService } from 'src/app/auth/auth.service';
import { TimerService } from '../timer/timer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modify-password',
  templateUrl: './modify-password.component.html',
  styleUrls: ['./modify-password.component.sass']
})
export class ModifyPasswordComponent implements OnInit {

  private eventsSubscription: Subscription;
  @Input() events: Observable<void>;
  tplModal: NzModalRef;
  @ViewChild('changePasswordModal') public changePasswordModalTemplateref: TemplateRef<any>;
  @ViewChild('changePasswordFooter') public changePasswordFooter: TemplateRef<any>;
  validateForm!: UntypedFormGroup;
  @Input() isVisible: boolean;
  isSpinning: boolean = false;
  otpCodeVisible: boolean;
  public otpCode: string = "";
  temporaryPasswordVisible = false;
  newPasswordVisible = false;
  confirmNewPasswordVisible = false;
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  errorMessage: string;
  customError: boolean = false;
  currentUser: User = null;
  otpSended: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private funcs: FuncsService,
    private logger: LogService,
    private identityService: IdentityService,
    private modalService: NzModalService,
    private authService: AuthService,
    public timerService: TimerService,
  ) { }

  ngOnInit(): void {
    this.eventsSubscription = this.events.subscribe(() => {
      this.tplModal = this.modalService.create({
        nzTitle: "Cambia la tua password",
        nzContent: this.changePasswordModalTemplateref,
        nzFooter: this.changePasswordFooter,
      });

      this.authService.currentUserChanged.subscribe((data: User) => {
        if (data == null) {
          this.tplModal.close();
        }
        else {
          this.currentUser = data;
          let reg = this.funcs.getValidationPattern("password")
            .replace("STRING1", this.currentUser.first_name.toLowerCase())
            .replace("STRING2", this.currentUser.last_name.toLowerCase())
            .replace("STRING3", this.currentUser.fiscal_code.toLowerCase())
            .replace("STRING4", this.currentUser.identityDocument.document_number.toLowerCase())
            .replace("STRING5", this.currentUser.phone_number.replace("+", ""))
            .replace("STRING6", this.currentUser.birth_date.toString().replace(/\-/gi, "\-"))
            .replace("STRING7", this.currentUser.email.toLowerCase())
            .replace("STRING8", this.currentUser.username.replace(/\./gi, "\."))

          this.validateForm.controls['newPassword'].setValidators([Validators.required, Validators.pattern(RegExp(reg))])
          this.validateForm.controls['confirmNewPassword'].setValidators([Validators.required, Validators.pattern(RegExp(reg))])
        }
      });

    });

    this.validateForm = this.fb.group({
      oldPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required, Validators.pattern(RegExp(this.funcs.getValidationPattern("password")))]],
      confirmNewPassword: [null, [Validators.required, Validators.pattern(RegExp(this.funcs.getValidationPattern("password")))]],
      otpCode: [null, [Validators.required]]
    }, { validators: passwordsDontMatchValidator });
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }

  onModifyPasswordChange() {
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }

    let oldPassword = this.validateForm.value["oldPassword"]
    let newPassword = this.validateForm.value["newPassword"]
    let confirmNewPassword = this.validateForm.value["confirmNewPassword"]
    let otp = this.validateForm.value["otpCode"]

    if (!oldPassword && !newPassword && !confirmNewPassword && !otp) {
      return;
    }

    this.isSpinning = true;

    this.identityService.changePasswordWithOTP(
      oldPassword,
      newPassword,
      otp
    )
      .subscribe(
        (response: GenericResponse) => {
          if (response["esito"] == "OK") {
            this.logger.log("Response OK");
            this.tplModal.close();
            if (environment.resetTimerWhenSubmit) {
              this.timerService.resetTimerSendOTP();
            }
          }
        },
        (err: Observable<never>) => {
          this.isSpinning = false;

        },
        () => { this.isSpinning = false; },
      );
  }

  activateSpin(value: boolean) {
    this.isSpinning = value;
  }
}
